import React, { useEffect, useState } from "react";
import { auth } from "../../FirebaseConfig";
import AdminAPI from "../../network/AdminAPI";
import SystemAPI from "../../network/SystemAPI";
import InBetweenOverlay from "../InBetweenOverlay";
export default function LoggedOut(){
    // const auth = getAuth(app)

    const [logoURL, setLogoURL] = useState('')
    const [productName, setProductName] = useState('')
    const [showLoading, setShowLoading] = useState(false)
    const [buttonColorHexValue, setButtonColorHexValue] = useState('')

    useEffect(()=>{
        // Match patient portal branding: solid Midnight background.
        document.body.style.backgroundColor = '#291B2B';
        document.body.style.backgroundImage = 'none';
        setShowLoading(true)
        auth.signOut().then(() => {
            let currentURL = window.location.href;

            SystemAPI.getProductBrandingFromURL(currentURL).then(data => {
                setLogoURL(data.ProductAltLogoURL);
                setProductName(data.Name)
                setButtonColorHexValue(data.ProductButtonColorHexValue)
                setShowLoading(false)
            })
        })
        .catch(e => {
            console.error(' an error occurred on logout', e)
        })

        
    },[])

    return (
        <React.Fragment>
            {/* <InBetweenOverlay showInBetween={true} zIndex={-10}/> */}
            <div className={showLoading ? "d-none" : "container min-vh-100 d-flex flex-column justify-content-center"}>
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: '#291B2B', zIndex: -1, }}></div>
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="card shadow" style={{ backgroundColor: '#3A2240', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 20, color: '#FEFAFF' }}>
                            <div className="card-title text-center" style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
                                <a href="/">
                                    <img src={logoURL}
                                        style={{ width: '200px', margin: '20px' }}
                                        className={'nav-logo'} alt={"logo"}
                                    />
                                </a>
                            </div>
                            <div className="card-body">
                            <div className="text-center">Logged out successfully</div>
                            {/* <p className="text-center mt-3">To log in to the <b>{customerName} Portal</b> again, press the button below.</p> */}
                                <div className={"row mt-4"}>
                                    <div className={"col-12"}>
                                        <a href={"/login"}>
                                            <button className={"btn btn-lg w-100"} style={{ backgroundColor: '#C9A8FB', color: '#291B2B', fontWeight: 600, borderRadius: 999 }}>
                                                Log In
                                            </button>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

